import { render } from "./bookReaderView.vue?vue&type=template&id=4d50b139&scoped=true&ts=true"
import script from "./bookReaderView.vue?vue&type=script&lang=ts"
export * from "./bookReaderView.vue?vue&type=script&lang=ts"

import "./bookReaderView.vue?vue&type=style&index=0&id=4d50b139&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d50b139"]])

export default __exports__